import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const BSLAccountSlice = createSlice({
  name: "bslaccount",
  initialState,
  reducers: {
    settingData: (state, action) => {
      const { field, value } = action.payload;
      state[field] = value;
    },

    settingObjectData: (state, action) => {
      const { mainField, field, value } = action.payload;
      state[mainField][field] = value;
    },

    resetApplyForIbanFlagCode(state) {
      state.ApplyForIbanFlagCode = null;
    },
  },
});

export const { settingObjectData, settingData, resetApplyForIbanFlagCode } = BSLAccountSlice.actions;

export default BSLAccountSlice.reducer;
